import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { UnitMissionCapabilityForUnitAndMissionDTO } from "../types/unitMissionCapabilityForUnitAndMissionDTO.ts";
import Problem from "../types/problem.ts";
import apiClient from "../main/apiClient.ts";

const useFetchDesiredCapabilitiesForOrganisation = (organisationId: string) => {
    return useQuery<UnitMissionCapabilityForUnitAndMissionDTO[], AxiosError>({
        queryKey: ["capabilitiesForUnits"],
        queryFn: () =>
          apiClient.get(`/organisation/${organisationId}/unitmissioncapability`).then((resp) => resp.data),
    });
}

const useFetchDesiredCapabilitiesForUnitAndMission = (organisationId: string, unitId: string, missionCode: string) => {
    return useQuery<UnitMissionCapabilityForUnitAndMissionDTO[], AxiosError>({
        queryKey: ["capabilitiesForUnitMission", unitId, missionCode],
        queryFn: () =>
          apiClient.get(`/organisation/${organisationId}/unitmissioncapability?unit=${unitId}&missioncode=${missionCode}`).then((resp) => resp.data),
    });
}

const useUpdateUnitMissionCapability = (organisationId: string) => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse[], AxiosError<Problem>, UnitMissionCapabilityForUnitAndMissionDTO[]>({
      mutationFn: (capabilityDTOs) => Promise.all(
        capabilityDTOs.map((capabilityDTO) => apiClient.put(`/organisation/${organisationId}/unitmissioncapability`, capabilityDTO))
      ),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["capability"] });
      }
    });
  };

const useAddUnitMissionCapability = (organisationId: string, setUnitMissionCapabilityState: (unitmissionCapability: UnitMissionCapabilityForUnitAndMissionDTO) => void) => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError<Problem>, UnitMissionCapabilityForUnitAndMissionDTO>({
      mutationFn: (capabilityDTO) => apiClient.post(`/organisation/${organisationId}/unitmissioncapability`, capabilityDTO),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["capability"] });
      },
      onError: (error, variables) => {
        console.log(error);
        setUnitMissionCapabilityState(variables);
      }
    });
}

const useDeleteUnitMissionCapability = (organisationId: string) => {
  return useMutation({
    mutationFn: async (unitMissionCapability: UnitMissionCapabilityForUnitAndMissionDTO) => {
      await apiClient.delete(`/organisation/${organisationId}/unitmissioncapability`, { data: unitMissionCapability });
    }
  });
};

export { useFetchDesiredCapabilitiesForOrganisation, useFetchDesiredCapabilitiesForUnitAndMission, useUpdateUnitMissionCapability, useAddUnitMissionCapability, useDeleteUnitMissionCapability }